module.exports = __webpack_public_path__ + "img/mailang.4b7eb8f9.png";